import React from "react";
import PropTypes from "prop-types";

const OverdueBooksCount = ({ overdueCount }) => {
  return (
    <span>
      {overdueCount} book{overdueCount !== 1 ? "s" : ""}
    </span>
  );
};

OverdueBooksCount.propTypes = {
  overdueCount: PropTypes.number.isRequired,
};

export default OverdueBooksCount;
